import { render, staticRenderFns } from "./HeadSearch.vue?vue&type=template&id=a4fafd5a"
import script from "./HeadSearch.vue?vue&type=script&lang=js"
export * from "./HeadSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports